import { render, staticRenderFns } from "./payCompleted.vue?vue&type=template&id=55858741&scoped=true&"
import script from "./payCompleted.vue?vue&type=script&lang=js&"
export * from "./payCompleted.vue?vue&type=script&lang=js&"
import style0 from "./payCompleted.vue?vue&type=style&index=0&id=55858741&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55858741",
  null
  
)

export default component.exports